import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import SearchIcon from '../../../../assets/images/SearchIcon.svg';
import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchWrapper: {
      position: 'relative',
    },
    search: {
      width: '100%',
      marginBottom: SMALL_MARGIN,
      padding: 10,
      paddingLeft: 45,
      fontSize: 16,
      color: colorsPalette.gray,
      background: theme.palette.secondary.light,
      borderRadius: 5,
      border: 'none',
      backgroundImage: `url(${SearchIcon})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '15px 50%',
      '&:focus': {
        outline: 'none',
      },
    },
    closeIconWrapper: {
      position: 'absolute',
      right: 6,
      top: 3,
      padding: 9,
    },
    closeIcon: {
      width: 14,
      height: 14,
    },
  }),
);

export default useStyles;
